import Vue from 'vue';
import Vuex from 'vuex';
import 'es6-promise/auto';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    accessToken: localStorage.getItem('accessToken'),
    member: localStorage.member ? JSON.parse(localStorage.getItem('member')) : {},
    loading: false,
    options: {},
    loginModal: false,
    forgotModal: false
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    setMember(state, member) {
      state.member = member ? member : {};
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setOptions(state, options) {
      state.options = options;
    },
    setLoginModal(state, value) {
      state.loginModal = value;
    },
    setForgotModal(state, value) {
      state.forgotModal = value;
    }
  }
})

export default store;